import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const CSRF_COOKIE_NAME = "csrf_token";
const CSRF_HEADER_NAME = "X-CSRF-Token";
const MUTATING_METHODS = new Set(["post", "put", "patch", "delete"]);

// photo_url de vehículo en las respuestas del backend es una ruta relativa
// pública ("/uploads/vehicle_photos/xxx.png") -- esto arma la URL completa
// para usar en <img src>. La foto de conductor NO usa esto: no se sirve
// como estática (ver resolveDriverPhotoUrl).
export const resolveUploadUrl = (photoUrl) => (photoUrl ? `${API_URL}${photoUrl}` : null);

// La foto de conductor es un dato personal -- se sirve solo autenticada,
// vía GET /api/conductores/{id}/foto (cookie de sesión httpOnly, el
// navegador la manda sola en el <img src>, igual que en cualquier request
// same-site). `profile.photo_url` no apunta a un archivo público: acá solo
// se usa su valor como query string para invalidar la caché del navegador
// cuando el conductor sube una foto nueva (el endpoint no lo necesita para
// resolver el archivo, solo cambia para que la URL cambie).
export const resolveDriverPhotoUrl = (profile) =>
  profile?.photo_url
    ? `${API_URL}/api/conductores/${profile.id}/foto?v=${encodeURIComponent(profile.photo_url)}`
    : null;

export const api = axios.create({
  baseURL: API_URL,
  // El backend ya no manda el JWT en el body -- vive en una cookie httpOnly
  // que el navegador adjunta solo. withCredentials hace que axios la envíe
  // (y guarde la que llegue) en requests cross-origin (localhost:3000 ->
  // localhost:8000 son orígenes distintos aunque compartan "sitio").
  withCredentials: true,
});

function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

// Patrón doble-submit: la cookie csrf_token (NO httpOnly, a diferencia de
// la de sesión) se lee acá y se manda de vuelta como header en cada
// request que muta estado. Un atacante cross-site no puede leer esta
// cookie (same-origin policy), así que no puede replicar el header aunque
// el navegador le dejara mandar la cookie sola.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (MUTATING_METHODS.has(method)) {
    const csrfToken = readCookie(CSRF_COOKIE_NAME);
    if (csrfToken) {
      config.headers[CSRF_HEADER_NAME] = csrfToken;
    }
  }
  return config;
});
